import { render, staticRenderFns } from "./ChecklistsChecklistItemControl.vue?vue&type=template&id=24f0ca2c&scoped=true"
import script from "./ChecklistsChecklistItemControl.vue?vue&type=script&lang=js"
export * from "./ChecklistsChecklistItemControl.vue?vue&type=script&lang=js"
import style0 from "./ChecklistsChecklistItemControl.vue?vue&type=style&index=0&id=24f0ca2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0ca2c",
  null
  
)

export default component.exports